import { headerNavigationLinkQueries } from "@circle-react/lib/queries/headerNavigationLinks";
import type {
  HeaderNavigationLinkAudience,
  HeaderNavigationLinkItem,
  HeaderNavigationLinkItemAudience,
  HeaderNavigationLinkItemKind,
  HeaderNavigationLinkVisibility,
} from "@circle-react/lib/queries/headerNavigationLinks";
import { useQuery } from "react-query";

export type HeaderNavItemKind = HeaderNavigationLinkItemKind;
export type HeaderNavItemVisibility = HeaderNavigationLinkVisibility;
export type HeaderNavItemAudience = HeaderNavigationLinkItemAudience;
export type HeaderNavAudienceApiParam = HeaderNavigationLinkAudience;
export type HeaderNavItem = HeaderNavigationLinkItem;

export interface UseFetchHeaderNavItemsProps {
  audience?: HeaderNavAudienceApiParam;
  id?: number | string;
}

export const useFetchHeaderNavItems = ({
  id,
  audience,
}: UseFetchHeaderNavItemsProps) =>
  useQuery({
    ...headerNavigationLinkQueries.list(audience),
    enabled: !!id,
  });
